import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Card, CardBody, CardTitle, Collapse,
} from 'reactstrap';
import { Form, actions } from 'react-redux-form/immutable';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LabeledText } from '../../../form/LabeledText';
import { LabeledSelect } from '../../../form/LabeledSelect';
import { referenceSearchModel, toSearchParameters } from './referenceSearchModel';
import {
  searchReferences as searchReferencesAc,
  clearReferenceSearch as clearReferenceSearchAc,
  getHaves as getHavesAc,

  getEqRegions as getEqRegionsAc,
  getEqCountries as getEqCountriesAc,
  getEqAreas as getEqAreasAc,

  getVolCountries as getVolCountriesAc,
  getVolRegions as getVolRegionsAc,
  getVolVolcanoNames as getVolVolcanoNamesAc,
  getVolMorphologies as getVolMorphologiesAc,

  getVolLocRegions as getVolLocRegionsAc,
  getVolLocCountries as getVolLocCountriesAc,
  getVolLocMorphologies as getVolLocMorphologiesAc,
  getVolLocStatuses as getVolLocStatusesAc,
  getVolLocEruptionTimes as getVolLocEruptionTimesAc,

  getTsuRegions as getTsuRegionsAc,
  getTsuCountries as getTsuCountriesAc,
  getTsuAreas as getTsuAreasAc,
  getTsuRunupCountries as getTsuRunupCountriesAc,
  getTsuRunupAreas as getTsuRunupAreasAc,
  getTsuRunupMeasurementTypes as getTsuRunupMeasurementTypesAc,
  getTsuCauses as getTsuCausesAc,
  getTsuValidities as getTsuValiditiesAc,

  getDepPublications as getDepPublicationsAc,
  getDepGeologicAges as getDepGeologicAgesAc,
  getDepBodiesOfWater as getDepBodiesOfWaterAc,
  getDepCountries as getDepCountriesAc,

  getRunupRegions as getRunupRegionsAc,
  getRunupCountries as getRunupCountriesAc,
  getRunupAreas as getRunupAreasAc,
  getRunupRunupCountries as getRunupRunupCountriesAc,
  getRunupRunupAreas as getRunupRunupAreasAc,
  getRunupRunupMeasurementTypes as getRunupRunupMeasurementTypesAc,
  getRunupCauses as getRunupCausesAc,
  getRunupValidities as getRunupValiditiesAc,

} from '../../../../redux/references/search/referenceSearchActions';
import { Loading } from '../../../loadbar/Loading';
import { TextMatchSearchCard } from '../../../form/search/TextMatchSearchCard';
import { MinMaxSearchCard } from '../../../form/search/MinMaxSearchCard';
import { EffectsSearchCard } from '../../../form/search/EffectsSearchCard';
import { MinMaxSelectSearchCard } from '../../../form/search/MinMaxSelectSearchCard';


const model = referenceSearchModel.get('name');

class ReferenceSearchPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.toggleColEq = this.toggleColEq.bind(this);
    this.toggleColVol = this.toggleColVol.bind(this);
    this.toggleColVolLoc = this.toggleColVolLoc.bind(this);
    this.toggleColTsu = this.toggleColTsu.bind(this);
    this.toggleColDep = this.toggleColDep.bind(this);
    this.toggleColRu = this.toggleColRu.bind(this);

    this.state = {
      collapseEarthquake: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Reference Search';
    const {
      history,
      clearReferenceSearch,
      getHaves,

      getEqRegions,
      getEqCountries,

      getVolCountries,
      getVolRegions,
      getVolVolcanoNames,
      getVolMorphologies,

      getVolLocCountries,
      getVolLocRegions,
      getVolLocMorphologies,
      getVolLocStatuses,
      getVolLocEruptionTimes,

      getTsuRegions,
      getTsuCountries,
      getTsuAreas,
      getTsuValidities,
      getTsuCauses,
      getTsuRunupCountries,
      getTsuRunupMeasurementTypes,

      getDepBodiesOfWater,
      getDepCountries,
      getDepGeologicAges,
      getDepPublications,

      getRunupRegions,
      getRunupCountries,
      getRunupRunupCountries,
      getRunupRunupMeasurementTypes,
      getRunupCauses,
      getRunupValidities,
    } = this.props;
    clearReferenceSearch();
    getHaves({ history });

    getEqRegions({ history });
    getEqCountries({ history });

    getVolCountries({ history });
    getVolRegions({ history });
    getVolVolcanoNames({ history });
    getVolMorphologies({ history });

    getVolLocCountries({ history });
    getVolLocRegions({ history });
    getVolLocMorphologies({ history });
    getVolLocStatuses({ history });
    getVolLocEruptionTimes({ history });

    getTsuRegions({ history });
    getTsuCountries({ history });
    getTsuAreas({ history });
    getTsuValidities({ history });
    getTsuCauses({ history });
    getTsuRunupCountries({ history });
    getTsuRunupMeasurementTypes({ history });

    getDepBodiesOfWater({ history });
    getDepCountries({ history });
    getDepGeologicAges({ history });
    getDepPublications({ history });

    getRunupRegions({ history });
    getRunupCountries({ history });
    getRunupRunupCountries({ history });
    getRunupRunupMeasurementTypes({ history });
    getRunupCauses({ history });
    getRunupValidities({ history });
  }

  componentDidUpdate(prevProps) {
    const {
      history,
      change,

      selectedEqCountry,
      selectedEqArea,
      getEqAreas,

      selectedTsuCountry,
      selectedTsuArea,
      selectedTsuRunupCountry,
      selectedTsuRunupArea,
      getTsuAreas,
      getTsuRunupAreas,

      selectedRunupCountry,
      selectedRunupArea,
      selectedRunupRunupCountry,
      selectedRunupRunupArea,
      getRunupAreas,
      getRunupRunupAreas,
    } = this.props;
    const {
      selectedEqCountry: prevSelectedEqCountry,
      selectedTsuCountry: prevSelectedTsuCountry,
      selectedTsuRunupCountry: prevSelectedTsuRunupCountry,
      selectedRunupCountry: prevSelectedRunupCountry,
      selectedRunupRunupCountry: prevSelectedRunupRunupCountry,
    } = prevProps;

    // earthquake related
    if (prevSelectedEqCountry !== selectedEqCountry) {
      if (selectedEqArea) {
        change('.eqArea', '');
      }
      if (selectedEqCountry) {
        getEqAreas({ eqCountry: selectedEqCountry, history });
      }
    }

    // tsunami related
    if (prevSelectedTsuCountry !== selectedTsuCountry) {
      if (selectedTsuArea) change('.tsuArea', '');
      if (selectedTsuCountry) {
        getTsuAreas({ tsuCountry: selectedTsuCountry, history });
      }
    }

    if (prevSelectedTsuRunupCountry !== selectedTsuRunupCountry) {
      if (selectedTsuRunupArea) change('.tsuRunupArea', '');
      if (selectedTsuRunupCountry) {
        getTsuRunupAreas({ tsuRunupCountry: selectedTsuRunupCountry, history });
      }
    }

    // runup related
    if (prevSelectedRunupCountry !== selectedRunupCountry) {
      if (selectedRunupArea) change('.runupArea', '');
      if (selectedRunupCountry) {
        getRunupAreas({ runupCountry: selectedRunupCountry, history });
      }
    }
    if (prevSelectedRunupRunupCountry !== selectedRunupRunupCountry) {
      if (selectedRunupRunupArea) change('.runupRunupArea', '');
      if (selectedRunupRunupCountry) {
        getRunupRunupAreas({ runupRunupCountry: selectedRunupRunupCountry, history });
      }
    }
  }

  handleSubmit(form) {
    const { searchReferences, history } = this.props;
    const queryParameters = toSearchParameters(form);
    const location = {
      pathname: '/view/reference/data',
      search: qs.stringify(toSearchParameters(form), { skipNulls: true }),
    };
    searchReferences({
      queryParameters, formModel: model, history, location, searchRedirect: true,
    });
  }

  toggleColEq() {
    this.setState(state => ({ collapseEarthquake: !state.collapseEarthquake }));
  }

  toggleColVol() {
    this.setState(state => ({ collapseVolcanoEvent: !state.collapseVolcanoEvent }));
  }

  toggleColVolLoc() {
    this.setState(state => ({ collapseVolcanoLocation: !state.collapseVolcanoLocation }));
  }

  toggleColTsu() {
    this.setState(state => ({ collapseTsunami: !state.collapseTsunami }));
  }

  toggleColDep() {
    this.setState(state => ({ collapseDeposit: !state.collapseDeposit }));
  }

  toggleColRu() {
    this.setState(state => ({ collapseRunup: !state.collapseRunup }));
  }

  render() {
    const {
      resetForm,
      searching,
      fetched,
      haves,

      // associated hazards
      eqRegions,
      eqCountries,
      eqAreas,
      eqFetchingAreas,

      volCountries,
      volRegions,
      volVolcanoNames,
      volMorphologies,

      volLocCountries,
      volLocRegions,
      volLocMorphologies,
      volLocStatuses,
      volLocEruptionTimes,

      tsuRegions,
      tsuCountries,
      tsuAreas,
      tsuFetchingAreas,
      tsuValidities,
      tsuCauses,
      tsuRunupCountries,
      tsuRunupAreas,
      tsuFetchingRunupAreas,
      tsuRunupMeasurementTypes,

      depPublications,
      depGeologicAges,
      depBodiesOfWater,
      depCountries,

      runupRegions,
      runupCountries,
      runupAreas,
      runupFetchingAreas,
      runupRunupCountries,
      runupRunupAreas,
      runupFetchingRunupAreas,
      runupRunupMeasurementTypes,
      runupValidities,
      runupCauses,

      peopleDescriptors,
      damageDescriptors,
      homeDescriptors,
    } = this.props;

    if (!fetched || searching) {
      return (<Loading />);
    }

    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const homeDescriptorsJs = homeDescriptors.toJS();

    // eslint-disable-next-line no-nested-ternary
    const tsuCausesJs = tsuCauses.toJS().sort((a, b) => ((parseInt(a.id, 10) > parseInt(b.id, 10)) ? 1 : ((parseInt(b.id, 10) > parseInt(a.id, 10)) ? -1 : 0)));
    const tsuCausesJs2 = tsuCauses.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));

    const depPublicationsJs = depPublications.toJS();
    const depGeologicAgesJs = depGeologicAges.toJS();
    const depBodiesOfWaterJs = depBodiesOfWater.toJS();
    const depCountriesJs = depCountries.toJS();

    const runupRegionsJs = runupRegions.toJS();
    const runupValiditiesJs = runupValidities.toJS();
    const runupCausesJs = runupCauses.toJS();

    const { collapseEarthquake } = this.state;
    const { collapseVolcanoEvent } = this.state;
    const { collapseVolcanoLocation } = this.state;
    const { collapseTsunami } = this.state;
    const { collapseDeposit } = this.state;
    const { collapseRunup } = this.state;

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search References</CardTitle>

            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Reference ID</CardTitle>
                  <LabeledText formGroupClassName={['col-sm-12']} model=".id" label="ID" />
                  <MinMaxSearchCard min=".minId" max=".maxId">ID Range</MinMaxSearchCard>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Reference Parameters</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-lg-4']} model=".year" label="Year" />
                    <LabeledSelect childOptions={haves.toJS()} formGroupClassName={['col-lg-8']} parentModel={model} fieldId="have" label="Have? and DB Status" sorted={false} prependId />
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.authorSearchType"
                    textModel=".radios.author"
                    startsWith="authorStart"
                    includes="authorInclude"
                    matches="authorMatch"
                    doesNotMatch="authorNot"
                  >
                    Author
                  </TextMatchSearchCard>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.citSearchType"
                    textModel=".radios.cit"
                    startsWith="citStart"
                    includes="citInclude"
                    matches="citMatch"
                    doesNotMatch="citNot"
                  >
                    Citation
                  </TextMatchSearchCard>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.commentsSearchType"
                    textModel=".radios.comments"
                    startsWith="commentsStart"
                    includes="commentsInclude"
                    matches="commentsMatch"
                    doesNotMatch="commentsNot"
                  >
                    Comments
                  </TextMatchSearchCard>
                </CardBody>
              </Card>

              {/* ---------------------------------------------------------- */}
              {/* ---------------------------------------------------------- */}
              {/* BEGIN EARTHQUAKE ASSOCIATION ------------
              ----------------- */}
              <hr />
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Associated Earthquake Parameters</CardTitle>

                  <Button color="primary" onClick={this.toggleColEq} style={{ marginBottom: '1rem' }}>Toggle Earthquake Parameters</Button>
                  <Collapse isOpen={collapseEarthquake}>
                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-md-12']}
                        parentModel={model}
                        fieldId="eqAssoc"
                        label="Earthquake"
                        unselectedText="None Selected"
                        childOptions={[
                          { id: 'no', description: 'Earthquake Was Not Associated' },
                          { id: 'yes', description: 'Earthquake Was Associated' },
                        ]}
                      />
                    </div>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Reference ID</CardTitle>
                        <LabeledText formGroupClassName={['col-sm-12']} model=".eqId" label="Earthquake ID" />
                        <MinMaxSearchCard min=".eqMinId" max=".eqMaxId">Earthquake ID Range</MinMaxSearchCard>
                      </CardBody>
                    </Card>

                    <MinMaxSearchCard min=".eqMinYear" max=".eqMaxYear" helpModalId="year">Earthquake Year</MinMaxSearchCard>

                    <div className="form-row">
                      <LabeledSelect childOptions={eqRegions.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="eqRegion" label="Region" filterable prependId helpModalId="region" />
                      <LabeledSelect childOptions={eqCountries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="eqCountry" label="Country" filterable readOnly={eqFetchingAreas} helpModalId="eqCountry" />
                      <LabeledSelect childOptions={eqAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="eqArea" label="Area" filterable helpModalId="eqArea" readOnly={eqFetchingAreas || !eqAreas.size} />
                    </div>

                    <TextMatchSearchCard
                      radioGroupModel=".radios.eqLocationSearchType"
                      textModel=".radios.eqLoc"
                      startsWith="eqLocStart"
                      includes="eqLocInclude"
                      matches="eqLocMatch"
                      doesNotMatch="eqLocNot"
                      helpModalId="eqLocName"
                    >
                      Earthquake Location
                    </TextMatchSearchCard>

                    {/* <LatLongSearchCard helpModalIdPrefix="eq" /> */}

                    <div className="form-row row-margin-fix">
                      <MinMaxSearchCard className="col-lg-6" min=".eqMinEqMagnitude" max=".eqMaxEqMagnitude" helpModalId="eqMagnitude">Earthquake Magnitude</MinMaxSearchCard>
                      <MinMaxSearchCard className="col-lg-6" min=".eqMinIntensity" max=".eqMaxIntensity" helpModalId="eqIntensity">Earthquake Intensity</MinMaxSearchCard>
                    </div>

                    <MinMaxSearchCard min=".eqMinEqDepth" max=".eqMaxEqDepth" helpModalId="eqFocalDepth">Earthquake Focal Depth (km)</MinMaxSearchCard>

                    <TextMatchSearchCard
                      radioGroupModel=".radios.eqCommentsSearchType"
                      textModel=".radios.eqComments"
                      startsWith="eqCommentsStart"
                      includes="eqCommentsInclude"
                      matches="eqCommentsMatch"
                      doesNotMatch="eqCommentsNot"
                      helpModalId="eqComments"
                    >
                      Earthquake Comments
                    </TextMatchSearchCard>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Earthquake Hazard Association</CardTitle>
                        <div className="form-row">
                          <LabeledSelect
                            formGroupClassName={['col-md-6']}
                            parentModel={model}
                            fieldId="eqAssocTsu"
                            label="Tsunami"
                            unselectedText="None Selected"
                            helpModalId="eqTsunami"
                            childOptions={[
                              { id: 'yes', description: 'Tsunami Was Associated' },
                              { id: 'no', description: 'Tsunami Was Not Associated' },
                            ]}
                          />
                          <LabeledSelect
                            formGroupClassName={['col-md-6']}
                            parentModel={model}
                            fieldId="eqAssocVol"
                            label="Volcanic Eruption"
                            unselectedText="None Selected"
                            helpModalId="eqVolcano"
                            childOptions={[
                              { id: 'yes', description: 'Eruption Was Associated' },
                              { id: 'no', description: 'Eruption Was Not Associated' },
                            ]}
                          />
                        </div>
                      </CardBody>
                    </Card>

                    <EffectsSearchCard
                      helpModalIdPrefix="eq"
                      deaths
                      damage
                      peopleDescriptors={peopleDescriptorsJs}
                      model={model}
                      damageDescriptors={damageDescriptorsJs}
                      minDeathsField=".eqMinDeaths"
                      maxDeathsField=".eqMaxDeaths"
                      minDeathsDescField="eqMinDeathsAmountOrder"
                      maxDeathsDescField="eqMaxDeathsAmountOrder"
                      minDamageField=".eqMinDamageMillionsDollars"
                      maxDamageField=".eqMaxDamageMillionsDollars"
                      minDamageDescField="eqMinDamageAmountOrder"
                      maxDamageDescField="eqMaxDamageAmountOrder"
                    >
                      Earthquake Effects
                    </EffectsSearchCard>

                    <EffectsSearchCard
                      helpModalIdPrefix="eq"
                      total
                      deaths
                      peopleDescriptors={peopleDescriptorsJs}
                      model={model}
                      minTotalDeathsField=".eqMinDeathsTotal"
                      maxTotalDeathsField=".eqMaxDeathsTotal"
                      minTotalDeathsDescField="eqMinDeathsAmountOrderTotal"
                      maxTotalDeathsDescField="eqMaxDeathsAmountOrderTotal"
                    >
                      Total Earthquake and Secondary Effects
                    </EffectsSearchCard>
                  </Collapse>
                </CardBody>
              </Card>

              {/* BEGIN VOLCANO EVENT ASSOCIATION -------------------------- */}
              <hr />
              <Card>
                <CardBody>
                  <CardTitle>Associated Volcano Event Parameters</CardTitle>

                  <Button color="primary" onClick={this.toggleColVol} style={{ marginBottom: '1rem' }}>Toggle Volcano Event Parameters</Button>

                  <Collapse isOpen={collapseVolcanoEvent}>

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-md-12']}
                        parentModel={model}
                        fieldId="volAssoc"
                        label="Volcano"
                        unselectedText="None Selected"
                        childOptions={[
                          { id: 'no', description: 'Volcano Was Not Associated' },
                          { id: 'yes', description: 'Volcano Was Associated' },
                        ]}
                      />
                    </div>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Volcano ID</CardTitle>
                        <LabeledText formGroupClassName={['col-sm-12']} model=".volId" label="Volcano Event ID" />
                        <MinMaxSearchCard min=".volMinId" max=".volMaxId">ID Range</MinMaxSearchCard>
                      </CardBody>
                    </Card>

                    <MinMaxSearchCard min=".volMinYear" max=".volMaxYear" helpModalId="volEventYear">Year</MinMaxSearchCard>

                    <TextMatchSearchCard
                      radioGroupModel=".radios.volLocationSearchType"
                      textModel=".radios.volLocation"
                      startsWith="volLocationStart"
                      includes="volLocationInclude"
                      matches="volLocationMatch"
                      doesNotMatch="volLocationNot"
                    >
                      Volcano Location
                    </TextMatchSearchCard>

                    <TextMatchSearchCard
                      radioGroupModel=".radios.volNameSearchType"
                      textModel=".radios.volName"
                      startsWith="volNameStart"
                      includes="volNameInclude"
                      matches="volNameMatch"
                      doesNotMatch="volNameNot"
                      helpModalId="volLocName"
                    >
                      Volcano Name
                    </TextMatchSearchCard>

                    <LabeledSelect
                      parentModel={model}
                      fieldId="volNameMatch"
                      label="Volcano Name Selection"
                      helpModalId="volLocName"
                      filterable
                      childOptions={volVolcanoNames.toJS()}
                    />

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-lg-6']}
                        parentModel={model}
                        fieldId="volCountry"
                        label="Volcano Country"
                        helpModalId="volEventCountry"
                        filterable
                        childOptions={volCountries.toJS()}
                      />
                      <LabeledSelect
                        formGroupClassName={['col-lg-6']}
                        parentModel={model}
                        fieldId="volRegion"
                        label="Volcano Region"
                        helpModalId="volLocRegion"
                        filterable
                        prependId
                        childOptions={volRegions.toJS()}
                      />
                    </div>

                    {/* <LatLongSearchCard /> */}

                    <LabeledSelect
                      parentModel={model}
                      fieldId="volMorphology"
                      label="Volcano Type"
                      helpModalId="volLocType"
                      filterable
                      childOptions={volMorphologies.toJS()}
                    />

                    <MinMaxSearchCard min=".volMinVei" max=".volMaxVei" helpModalId="volEventVei">VEI</MinMaxSearchCard>

                    <TextMatchSearchCard
                      radioGroupModel=".radios.volCommentsSearchType"
                      textModel=".radios.volComments"
                      startsWith="volCommentsStart"
                      includes="volCommentsInclude"
                      matches="volCommentsMatch"
                      doesNotMatch="volCommentsNot"
                      helpModalId="volEventComments"
                    >
                      Event Comments
                    </TextMatchSearchCard>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Volcano Hazard Association</CardTitle>
                        <div className="form-row">
                          <LabeledSelect
                            formGroupClassName={['col-md-6']}
                            parentModel={model}
                            fieldId="volAssocTsu"
                            label="Tsunami"
                            unselectedText="None Selected"
                            helpModalId="volTsunami"
                            childOptions={[
                              { id: 'yes', description: 'Tsunami Was Associated' },
                              { id: 'no', description: 'Tsunami Was Not Associated' },
                            ]}
                          />
                          <LabeledSelect
                            formGroupClassName={['col-md-6']}
                            parentModel={model}
                            fieldId="volAssocEq"
                            label="Earthquake"
                            unselectedText="None Selected"
                            helpModalId="volEarthquake"
                            childOptions={[
                              { id: 'yes', description: 'Earthquake Was Associated' },
                              { id: 'no', description: 'Earthquake Was Not Associated' },
                            ]}
                          />
                        </div>
                      </CardBody>
                    </Card>

                    <EffectsSearchCard
                      helpModalIdPrefix="volEvent"
                      deaths
                      damage
                      peopleDescriptors={peopleDescriptorsJs}
                      model={model}
                      damageDescriptors={damageDescriptorsJs}
                      minDeathsField=".volMinDeaths"
                      maxDeathsField=".volMaxDeaths"
                      minDeathsDescField="volMinDeathsAmountOrder"
                      maxDeathsDescField="volMaxDeathsAmountOrder"
                      minDamageField=".volMinDamageMillionsDollars"
                      maxDamageField=".volMaxDamageMillionsDollars"
                      minDamageDescField="volMinDamageAmountOrder"
                      maxDamageDescField="volMaxDamageAmountOrder"
                    >
                      Volcano Effects
                    </EffectsSearchCard>

                  </Collapse>
                </CardBody>
              </Card>

              {/* BEGIN VOLCANO LOCATION ASSOCIATION ----------------------- */}
              <hr />
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Associated Volcano Location Parameters</CardTitle>

                  <Button color="primary" onClick={this.toggleColVolLoc} style={{ marginBottom: '1rem' }}>Toggle Volcano Location Parameters</Button>

                  <Collapse isOpen={collapseVolcanoLocation}>

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-md-12']}
                        parentModel={model}
                        fieldId="volLocAssoc"
                        label="Volcano Location"
                        unselectedText="None Selected"
                        childOptions={[
                          { id: 'no', description: 'Volcano Location Was Not Associated' },
                          { id: 'yes', description: 'Volcano Location Was Associated' },
                        ]}
                      />
                    </div>

                    <CardTitle tag="h2">Volcano Parameters</CardTitle>

                    <TextMatchSearchCard
                      radioGroupModel=".radios.volLocNameSearchType"
                      textModel=".radios.volLocName"
                      startsWith="volLocNameStart"
                      includes="volLocNameInclude"
                      matches="volLocNameMatch"
                      doesNotMatch="volLocNameNot"
                      helpModalId="volLocName"
                    >
                      Volcano Name
                    </TextMatchSearchCard>

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-lg-6']}
                        parentModel={model}
                        fieldId="volLocCountry"
                        label="Country"
                        filterable
                        helpModalId="volEventCountry"
                        childOptions={volLocCountries.toJS()}
                      />

                      <LabeledSelect childOptions={volLocRegions.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="volLocRegion" label="Region" filterable prependId helpModalId="volLocRegion" />
                    </div>

                    {/* <LatLongSearchCard /> */}

                    <div className="form-row">
                      <LabeledSelect childOptions={volLocMorphologies.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="volLocMorphology" label="Volcano Type" filterable helpModalId="volLocType" />
                      <LabeledSelect childOptions={volLocStatuses.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="volLocStatus" label="Volcano Status" filterable helpModalId="volLocStatus" />
                      <LabeledSelect childOptions={volLocEruptionTimes.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="volLocTimeErupt" label="Time of Eruption" filterable helpModalId="volLocTimeErupt" />
                    </div>
                  </Collapse>
                </CardBody>
              </Card>

              {/* BEGIN TSUNAMI ASSOCIATION -------------------------------- */}
              <hr />
              <Card>
                <CardBody>
                  <CardTitle>Associated Tsunami Parameters</CardTitle>

                  <Button color="primary" onClick={this.toggleColTsu} style={{ marginBottom: '1rem' }}>Toggle Tsunami Parameters</Button>

                  <Collapse isOpen={collapseTsunami}>

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-md-12']}
                        parentModel={model}
                        fieldId="tsuAssoc"
                        label="Tsunami"
                        unselectedText="None Selected"
                        childOptions={[
                          { id: 'no', description: 'Tsunami Was Not Associated' },
                          { id: 'yes', description: 'Tsunami Was Associated' },
                        ]}
                      />
                    </div>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Tsunami ID</CardTitle>
                        <LabeledText model=".tsuId" label="Tsunami ID" />
                        <MinMaxSearchCard min=".tsuMinId" max=".tsuMaxId">ID Range</MinMaxSearchCard>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Tsunami Source Parameters</CardTitle>

                        <MinMaxSearchCard min=".tsuMinYear" max=".tsuMaxYear" helpModalId="year">Year</MinMaxSearchCard>

                        <div className="form-row">
                          <LabeledSelect childOptions={tsuRegions.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="tsuRegionCode" label="Region" filterable prependId />
                          <LabeledSelect childOptions={tsuCountries.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="tsuCountry" label="Country" filterable readOnly={tsuFetchingAreas} helpModalId="tsuCountry" />
                          <LabeledSelect childOptions={tsuAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="tsuArea" label="Area" readOnly={tsuFetchingAreas || !tsuAreas.size} filterable />
                        </div>

                        {/* <LatLongSearchCard helpModalIdPrefix="tsu" /> */}

                        <MinMaxSelectSearchCard
                          model={model}
                          minField="tsuMinEventValidity"
                          maxField="tsuMaxEventValidity"
                          descriptors={tsuValidities.toJS()}
                          prependId
                          helpModalId="tsuValidity"
                        >
                          Validity
                        </MinMaxSelectSearchCard>

                        <MinMaxSelectSearchCard
                          model={model}
                          minField="tsuMinCauseCode"
                          maxField="tsuMaxCauseCode"
                          descriptors={tsuCausesJs}
                          prependId
                          helpModalId="tsuCauseCode"
                        >
                          Cause of Tsunami
                        </MinMaxSelectSearchCard>

                        <Card>
                          <CardBody>
                            <div className="form-row">
                              <LabeledSelect childOptions={tsuCausesJs2} formGroupClassName={['col-12']} parentModel={model} fieldId="tsuCauseCode" label="Cause of Tsunami" multiselect filterable helpModalId="tsuCauseCode" />
                            </div>
                          </CardBody>
                        </Card>


                        <MinMaxSearchCard min=".tsuMinEqMagnitude" max=".tsuMaxEqMagnitude" helpModalId="eqMagnitude">Earthquake Magnitude</MinMaxSearchCard>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.tsuLocationSearchType"
                          textModel=".radios.tsuLoc"
                          startsWith="tsuLocStart"
                          includes="tsuLocInclude"
                          matches="tsuLocMatch"
                          doesNotMatch="tsuLocNot"
                          helpModalId="tsuLocationName"
                        >
                          Location
                        </TextMatchSearchCard>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.tsuCommentsSearchType"
                          textModel=".radios.tsuComments"
                          startsWith="tsuCommentsStart"
                          includes="tsuCommentsInclude"
                          matches="tsuCommentsMatch"
                          doesNotMatch="tsuCommentsNot"
                          helpModalId="tsuComments"
                        >
                          Comments
                        </TextMatchSearchCard>

                        <MinMaxSearchCard min=".tsuMinMaxWaterHeight" max=".tsuMaxMaxWaterHeight" helpModalId="tsuMaxWaterHeight">Maximum Water Height (m)</MinMaxSearchCard>

                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Runup Parameters</CardTitle>
                        <MinMaxSearchCard min=".tsuMinNumRunups" max=".tsuMaxNumRunups" helpModalId="tsuRunups">Number of Runups</MinMaxSearchCard>
                        <div className="form-row">
                          <LabeledSelect
                            formGroupClassName={['col-lg-6']}
                            parentModel={model}
                            fieldId="tsuRunupMeasureType"
                            label="Type of Measurement"
                            sorted={false}
                            prependId
                            helpModalId="ruMeasurementType"
                            childOptions={tsuRunupMeasurementTypes.toJS()}
                          />
                          <LabeledSelect
                            formGroupClassName={['col-lg-6']}
                            parentModel={model}
                            fieldId="tsuRunupDoubtful"
                            label="Validity of Runup"
                            sorted={false}
                            unselectedText="Select Doubtfulness"
                            helpModalId="ruDoubtful"
                            childOptions={[
                              { id: 'n', description: 'OK' },
                              { id: 'y', description: 'Doubtful' },
                              { id: 'm', description: 'Meteorological' },
                              { id: 'a', description: 'Atmospheric' },
                            ]}
                          />
                        </div>
                        <MinMaxSearchCard min=".tsuRunupMinHeight" max=".tsuRunupMaxHeight" helpModalId="ruHeight">Vertical Height at Runup Location (m)</MinMaxSearchCard>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Tsunami Runup By Place</CardTitle>

                        <div className="form-row">
                          <LabeledSelect childOptions={tsuRegions.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="tsuRunupRegion" label="Region" filterable prependId />
                          <LabeledSelect childOptions={tsuRunupCountries.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="tsuRunupCountry" label="Country" readOnly={tsuFetchingRunupAreas} filterable helpModalId="ruCountry" />
                          <LabeledSelect childOptions={tsuRunupAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="tsuRunupArea" label="Area" readOnly={tsuFetchingRunupAreas || !tsuRunupAreas.size} filterable helpModalId="ruArea" />
                        </div>

                        <div className="form-row row-margin-fix">
                          <MinMaxSearchCard className="col-md-6" min=".tsuRunupMinDistance" max=".tsuRunupMaxDistance" helpModalId="ruDistance">Distance of Runup Location (km)</MinMaxSearchCard>
                          <MinMaxSearchCard className="col-md-6" min=".tsuRunupMinTravelTime" max=".tsuRunupMaxTravelTime" helpModalId="ruWaveTravelHour">Travel Time (hours)</MinMaxSearchCard>
                        </div>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.tsuRunupLocationSearchType"
                          textModel=".radios.tsuRunupLoc"
                          startsWith="tsuRunupLocStart"
                          includes="tsuRunupLocInclude"
                          matches="tsuRunupLocMatch"
                          doesNotMatch="tsuRunupLocNot"
                          helpModalId="ruLocation"
                        >
                          Runup Location
                        </TextMatchSearchCard>

                      </CardBody>
                    </Card>

                    <EffectsSearchCard
                      helpModalIdPrefix="tsu"
                      deaths
                      damage
                      injuries
                      housedDestroyed
                      model={model}
                      peopleDescriptors={peopleDescriptorsJs}
                      damageDescriptors={damageDescriptorsJs}
                      housesDescriptors={homeDescriptorsJs}
                      minDeathsField=".tsuMinDeaths"
                      maxDeathsField=".tsuMaxDeaths"
                      minDeathsDescField="tsuMinDeathsAmountOrder"
                      maxDeathsDescField="tsuMaxDeathsAmountOrder"
                      minInjuriesField=".tsuMinInjuries"
                      maxInjuriesField=".tsuMaxInjuries"
                      minInjuriesDescField="tsuMinInjuriesAmountOrder"
                      maxInjuriesDescField="tsuMaxInjuriesAmountOrder"
                      minDamageField=".tsuMinDamageMillionsDollars"
                      maxDamageField=".tsuMaxDamageMillionsDollars"
                      minDamageDescField="tsuMinDamageAmountOrder"
                      maxDamageDescField="tsuMaxDamageAmountOrder"
                      minHousesDestroyedField=".tsuMinHousesDestroyed"
                      maxHousesDestroyedField=".tsuMaxHousesDestroyed"
                      minHousesDestroyedDescField="tsuMinHousesDestroyedAmountOrder"
                      maxHousesDestroyedDescField="tsuMaxHousesDestroyedAmountOrder"
                    >
                      Tsunami Effects
                    </EffectsSearchCard>

                    <EffectsSearchCard
                      helpModalIdPrefix="tsu"
                      total
                      deaths
                      damage
                      model={model}
                      peopleDescriptors={peopleDescriptorsJs}
                      damageDescriptors={damageDescriptorsJs}
                      minTotalDeathsField=".tsuMinDeathsTotal"
                      maxTotalDeathsField=".tsuMaxDeathsTotal"
                      minTotalDeathsDescField="tsuMinDeathsAmountOrderTotal"
                      maxTotalDeathsDescField="tsuMaxDeathsAmountOrderTotal"
                      minTotalDamageField=".tsuMinDamageMillionsDollarsTotal"
                      maxTotalDamageField=".tsuMaxDamageMillionsDollarsTotal"
                      minTotalDamageDescField="tsuMinDamageAmountOrderTotal"
                      maxTotalDamageDescField="tsuMaxDamageAmountOrderTotal"
                    >
                      Total Tsunami and Source Effects
                    </EffectsSearchCard>

                    <EffectsSearchCard
                      helpModalIdPrefix="ru"
                      deaths
                      damage
                      injuries
                      housedDestroyed
                      model={model}
                      peopleDescriptors={peopleDescriptorsJs}
                      damageDescriptors={damageDescriptorsJs}
                      housesDescriptors={homeDescriptorsJs}
                      minDeathsField=".tsuRunupMinDeaths"
                      maxDeathsField=".tsuRunupMaxDeaths"
                      minDeathsDescField="tsuRunupMinDeathsAmountOrder"
                      maxDeathsDescField="tsuRunupMaxDeathsAmountOrder"
                      minInjuriesField=".tsuRunupMinInjuries"
                      maxInjuriesField=".tsuRunupMaxInjuries"
                      minInjuriesDescField="tsuRunupMinInjuriesAmountOrder"
                      maxInjuriesDescField="tsuRunupMaxInjuriesAmountOrder"
                      minDamageField=".tsuRunupMinDamageMillionsDollars"
                      maxDamageField=".tsuRunupMaxDamageMillionsDollars"
                      minDamageDescField="tsuRunupMinDamageAmountOrder"
                      maxDamageDescField="tsuRunupMaxDamageAmountOrder"
                      minHousesDestroyedField=".tsuRunupMinHousesDestroyed"
                      maxHousesDestroyedField=".tsuRunupMaxHousesDestroyed"
                      minHousesDestroyedDescField="tsuRunupMinHousesDestroyedAmountOrder"
                      maxHousesDestroyedDescField="tsuRunupMaxHousesDestroyedAmountOrder"
                    >
                      Effects at Runup Location
                    </EffectsSearchCard>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Event Has Associated Deposits</CardTitle>
                        <div className="form-row">
                          <LabeledSelect
                            formGroupClassName={['col-md-12']}
                            parentModel={model}
                            fieldId="tsuAssocDeposits"
                            label="Associated Deposits"
                            unselectedText="None Selected"
                            childOptions={[
                              { id: 'no', description: 'Deposits Were Not Associated' },
                              { id: 'yes', description: 'Deposits Were Associated' },
                            ]}
                          />
                        </div>
                      </CardBody>
                    </Card>

                  </Collapse>
                </CardBody>
              </Card>

              {/* BEGIN DEPOSIT ASSOCIATION -------------------------------- */}
              <hr />
              <Card>
                <CardBody>
                  <CardTitle>Associated Deposit Parameters</CardTitle>

                  <Button color="primary" onClick={this.toggleColDep} style={{ marginBottom: '1rem' }}>Toggle Deposit Parameters</Button>

                  <Collapse isOpen={collapseDeposit}>

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-md-12']}
                        parentModel={model}
                        fieldId="depAssoc"
                        label="Deposit"
                        unselectedText="None Selected"
                        childOptions={[
                          { id: 'no', description: 'Deposit Was Not Associated' },
                          { id: 'yes', description: 'Deposit Was Associated' },
                        ]}
                      />
                    </div>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Deposit ID</CardTitle>
                        <LabeledText model=".depId" label="ID" />
                        <MinMaxSearchCard min=".depMinId" max=".depMaxId">ID Range</MinMaxSearchCard>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Deposit Parameters</CardTitle>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.depAuthorSearchType"
                          textModel=".radios.depAuthor"
                          startsWith="depAuthorStart"
                          includes="depAuthorInclude"
                          matches="depAuthorMatch"
                          doesNotMatch="depAuthorNot"
                        >
                          Author
                        </TextMatchSearchCard>

                        <div className="form-row">
                          <LabeledSelect childOptions={depPublicationsJs} formGroupClassName={['col']} parentModel={model} fieldId="depPublicationType" label="Publication Type" prependId />
                        </div>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.depEventSearchType"
                          textModel=".radios.depEvent"
                          startsWith="depEventStart"
                          includes="depEventInclude"
                          matches="depEventMatch"
                          doesNotMatch="depEventNot"
                        >
                          Event Description
                        </TextMatchSearchCard>

                        <div className="form-row row-margin-fix">
                          <MinMaxSelectSearchCard
                            className="col-lg-9"
                            model={model}
                            minField="depMaxGeologicAgeId"
                            maxField="depMinGeologicAgeId"
                            descriptors={depGeologicAgesJs}
                            prependId
                            descending
                            minLabel="Min (youngest)"
                            maxLabel="Max (oldest)"
                          >
                            Geologic Age
                          </MinMaxSelectSearchCard>

                          <MinMaxSearchCard
                            className="col-lg-3"
                            min=".depMinYear"
                            max=".depMaxYear"
                          >
                            Year, example: 200 B.C. = -200
                          </MinMaxSearchCard>
                        </div>

                        <div className="form-row">
                          <LabeledSelect childOptions={depBodiesOfWaterJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="depBodyOfWater" label="Body of Water" filterable />
                          <LabeledSelect childOptions={depCountriesJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="depCountry" label="Country" filterable />
                        </div>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.depLocationSearchType"
                          textModel=".radios.depLoc"
                          startsWith="depLocStart"
                          includes="depLocInclude"
                          matches="depLocMatch"
                          doesNotMatch="depLocNot"
                        >
                          Location
                        </TextMatchSearchCard>

                        {/* <LatLongSearchCard /> */}

                      </CardBody>
                    </Card>
                  </Collapse>
                </CardBody>
              </Card>

              {/* BEGIN RUNUP ASSOCIATION ---------------------------------- */}
              <hr />
              <Card>
                <CardBody>
                  <CardTitle>Associated Runup Parameters</CardTitle>

                  <Button color="primary" onClick={this.toggleColRu} style={{ marginBottom: '1rem' }}>Toggle Runup Parameters</Button>

                  <Collapse isOpen={collapseRunup}>

                    <div className="form-row">
                      <LabeledSelect
                        formGroupClassName={['col-md-12']}
                        parentModel={model}
                        fieldId="runupAssoc"
                        label="Runup"
                        unselectedText="None Selected"
                        childOptions={[
                          { id: 'no', description: 'Runup Was Not Associated' },
                          { id: 'yes', description: 'Runup Was Associated' },
                        ]}
                      />
                    </div>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Runup ID</CardTitle>
                        <LabeledText model=".runupId" label="ID" />
                        <MinMaxSearchCard min=".runupMinId" max=".runupMaxId">ID Range</MinMaxSearchCard>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Tsunami Source Information</CardTitle>

                        <MinMaxSearchCard min=".runupSourceMinYear" max=".runupSourceMaxYear" helpModalId="year">Year</MinMaxSearchCard>

                        <div className="form-row">
                          <LabeledSelect childOptions={runupRegionsJs} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="runupSourceRegionCode" label="Source Region" filterable prependId />
                          <LabeledSelect childOptions={runupCountries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="runupCountry" label="Source Country" filterable readOnly={runupFetchingAreas} />
                          <LabeledSelect childOptions={runupAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="runupArea" label="Source Area" filterable readOnly={runupFetchingAreas || !runupAreas.size} />
                        </div>

                        <MinMaxSelectSearchCard model={model} minField="runupSourceMinEventValidity" maxField="runupSourceMaxEventValidity" descriptors={runupValiditiesJs} prependId helpModalId="tsuValidity">Source Validity</MinMaxSelectSearchCard>
                        <MinMaxSelectSearchCard model={model} minField="runupSourceMinCauseCode" maxField="runupSourceMaxCauseCode" descriptors={runupCausesJs} prependId helpModalId="tsuCauseCode">Cause of Tsunami</MinMaxSelectSearchCard>

                        <MinMaxSearchCard min=".runupSourceMinEqMagnitude" max=".runupSourceMaxEqMagnitude" helpModalId="eqMagnitude">Earthquake Magnitude</MinMaxSearchCard>

                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Tsunami Runup Location Information</CardTitle>
                        <div className="form-row">
                          <LabeledSelect childOptions={runupRegionsJs} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="runupRegionCode" label="Region" filterable prependId />
                          <LabeledSelect childOptions={runupRunupCountries.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="runupRunupCountry" label="Country" filterable readOnly={runupFetchingRunupAreas} helpModalId="ruCountry" />
                          <LabeledSelect childOptions={runupRunupAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="runupRunupArea" label="Area" filterable readOnly={runupFetchingRunupAreas || !runupRunupAreas.size} helpModalId="ruArea" />
                        </div>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.runupLocationSearchType"
                          textModel=".radios.runupLoc"
                          startsWith="runupLocStart"
                          includes="runupLocInclude"
                          matches="runupLocMatch"
                          doesNotMatch="runupLocNot"
                          helpModalId="ruLocation"
                        >
                          Location
                        </TextMatchSearchCard>

                        <div className="form-row row-margin-fix">
                          <MinMaxSearchCard className="col-md-6" min=".runupMinDistFromSource" max=".runupMaxDistFromSource" helpModalId="ruDistance">Distance From Source (km)</MinMaxSearchCard>
                          <MinMaxSearchCard className="col-md-6" min=".runupMinTravHours" max=".runupMaxTravHours" helpModalId="ruWaveTravelHour">Travel Time (Hours)</MinMaxSearchCard>
                        </div>

                        {/* <LatLongSearchCard helpModalIdPrefix="tsu" /> */}

                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <CardTitle tag="h2">Tsunami Runup Parameters</CardTitle>

                        <div className="form-row row-margin-fix">
                          <LabeledSelect childOptions={runupRunupMeasurementTypes.toJS()} formGroupClassName={['col-lg-8']} parentModel={model} fieldId="runupTypeMeasurementId" label="Type of Measurement" sorted={false} prependId helpModalId="ruMeasurementType" />

                          <LabeledSelect
                            formGroupClassName={['col-lg-4']}
                            parentModel={model}
                            fieldId="runupDoubtful"
                            label="Doubtfulness"
                            sorted={false}
                            unselectedText="Select Doubtfulness"
                            helpModalId="ruDoubtful"
                            childOptions={[
                              { id: 'n', description: 'OK' },
                              { id: 'y', description: 'Doubtful' },
                              { id: 'm', description: 'Meteorological' },
                              { id: 'a', description: 'Atmospheric' },
                            ]}
                          />
                        </div>

                        <div className="form-row row-margin-fix">
                          <MinMaxSearchCard className="col-md-4" min=".runupMinRunupHt" max=".runupMaxRunupHt" helpModalId="ruHeight">Water Height (m)</MinMaxSearchCard>
                          <MinMaxSearchCard className="col-md-4" min=".runupMinTroughHt" max=".runupMaxTroughHt" helpModalId="ruTroughHt">Max Trough Height (m)</MinMaxSearchCard>
                          <MinMaxSearchCard className="col-md-4" min=".runupMinRunupHoriz" max=".runupMaxRunupHoriz" helpModalId="ruInundation">Max Inundation Distance (m)</MinMaxSearchCard>
                        </div>

                        <TextMatchSearchCard
                          radioGroupModel=".radios.runupCommentsSearchType"
                          textModel=".radios.runupComments"
                          startsWith="runupCommentsStart"
                          includes="runupCommentsInclude"
                          matches="runupCommentsMatch"
                          doesNotMatch="runupCommentsNot"
                          helpModalId="ruComments"
                        >
                          Comments
                        </TextMatchSearchCard>

                      </CardBody>
                    </Card>

                    <EffectsSearchCard
                      helpModalIdPrefix="ru"
                      deaths
                      injuries
                      damage
                      housedDestroyed
                      housedDamaged
                      model={model}
                      peopleDescriptors={peopleDescriptorsJs}
                      damageDescriptors={damageDescriptorsJs}
                      housesDescriptors={homeDescriptorsJs}
                      minDeathsField=".runupMinDeaths"
                      maxDeathsField=".runupMaxDeaths"
                      minDeathsDescField="runupMinDeathsAmountOrder"
                      maxDeathsDescField="runupMaxDeathsAmountOrder"
                      minInjuriesField=".runupMinInjuries"
                      maxInjuriesField=".runupMaxInjuries"
                      minInjuriesDescField="runupMinInjuriesAmountOrder"
                      maxInjuriesDescField="runupMaxInjuriesAmountOrder"
                      minDamageField=".runupMinDamageMillionsDollars"
                      maxDamageField=".runupMaxDamageMillionsDollars"
                      minDamageDescField="runupMinDamageAmountOrder"
                      maxDamageDescField="runupMaxDamageAmountOrder"
                      minHousesDestroyedField=".runupMinHousesDestroyed"
                      maxHousesDestroyedField=".runupMaxHousesDestroyed"
                      minHousesDestroyedDescField="runupMinHousesDestroyedAmountOrder"
                      maxHousesDestroyedDescField="runupMaxHousesDestroyedAmountOrder"
                      minHousesDamagedField=".runupMinHousesDamaged"
                      maxHousesDamagedField=".runupMaxHousesDamaged"
                      minHousesDamagedDescField="runupMinHousesDamagedAmountOrder"
                      maxHousesDamagedDescField="runupMaxHousesDamagedAmountOrder"
                    >
                      Runup Effects
                    </EffectsSearchCard>

                  </Collapse>
                </CardBody>
              </Card>
              {/* ---------------------------------------------------------- */}
              {/* ---------------------------------------------------------- */}
              {/* ---------------------------------------------------------- */}

              <br />
              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

ReferenceSearchPageUnwrapped.propTypes = {
  searchReferences: PropTypes.func.isRequired,
  clearReferenceSearch: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  fetched: PropTypes.bool.isRequired,
  getHaves: PropTypes.func.isRequired,
  haves: ImmutablePropTypes.list.isRequired,

  // associated hazards
  getEqRegions: PropTypes.func.isRequired,
  getEqCountries: PropTypes.func.isRequired,
  getEqAreas: PropTypes.func.isRequired,
  eqRegions: ImmutablePropTypes.list.isRequired,
  eqCountries: ImmutablePropTypes.list.isRequired,
  eqAreas: ImmutablePropTypes.list.isRequired,
  eqFetchingAreas: PropTypes.bool.isRequired,

  getVolCountries: PropTypes.func.isRequired,
  getVolRegions: PropTypes.func.isRequired,
  getVolVolcanoNames: PropTypes.func.isRequired,
  getVolMorphologies: PropTypes.func.isRequired,
  volCountries: ImmutablePropTypes.list.isRequired,
  volRegions: ImmutablePropTypes.list.isRequired,
  volVolcanoNames: ImmutablePropTypes.list.isRequired,
  volMorphologies: ImmutablePropTypes.list.isRequired,

  getVolLocCountries: PropTypes.func.isRequired,
  getVolLocRegions: PropTypes.func.isRequired,
  getVolLocMorphologies: PropTypes.func.isRequired,
  getVolLocStatuses: PropTypes.func.isRequired,
  getVolLocEruptionTimes: PropTypes.func.isRequired,
  volLocCountries: ImmutablePropTypes.list.isRequired,
  volLocRegions: ImmutablePropTypes.list.isRequired,
  volLocMorphologies: ImmutablePropTypes.list.isRequired,
  volLocStatuses: ImmutablePropTypes.list.isRequired,
  volLocEruptionTimes: ImmutablePropTypes.list.isRequired,

  getTsuRegions: PropTypes.func.isRequired,
  getTsuCountries: PropTypes.func.isRequired,
  getTsuAreas: PropTypes.func.isRequired,
  getTsuRunupCountries: PropTypes.func.isRequired,
  getTsuRunupAreas: PropTypes.func.isRequired,
  getTsuRunupMeasurementTypes: PropTypes.func.isRequired,
  getTsuValidities: PropTypes.func.isRequired,
  getTsuCauses: PropTypes.func.isRequired,
  tsuRegions: ImmutablePropTypes.list.isRequired,
  tsuCountries: ImmutablePropTypes.list.isRequired,
  tsuAreas: ImmutablePropTypes.list.isRequired,
  tsuRunupCountries: ImmutablePropTypes.list.isRequired,
  tsuRunupAreas: ImmutablePropTypes.list.isRequired,
  tsuFetchingAreas: PropTypes.bool.isRequired,
  tsuFetchingRunupAreas: PropTypes.bool.isRequired,
  tsuValidities: ImmutablePropTypes.list.isRequired,
  tsuRunupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  tsuCauses: ImmutablePropTypes.list.isRequired,

  getDepPublications: PropTypes.func.isRequired,
  getDepBodiesOfWater: PropTypes.func.isRequired,
  getDepCountries: PropTypes.func.isRequired,
  getDepGeologicAges: PropTypes.func.isRequired,
  depPublications: ImmutablePropTypes.list.isRequired,
  depBodiesOfWater: ImmutablePropTypes.list.isRequired,
  depCountries: ImmutablePropTypes.list.isRequired,
  depGeologicAges: ImmutablePropTypes.list.isRequired,

  getRunupRegions: PropTypes.func.isRequired,
  getRunupCountries: PropTypes.func.isRequired,
  getRunupAreas: PropTypes.func.isRequired,
  getRunupRunupCountries: PropTypes.func.isRequired,
  getRunupRunupAreas: PropTypes.func.isRequired,
  getRunupRunupMeasurementTypes: PropTypes.func.isRequired,
  getRunupValidities: PropTypes.func.isRequired,
  getRunupCauses: PropTypes.func.isRequired,
  runupFetchingRunupAreas: PropTypes.bool.isRequired,
  runupFetchingAreas: PropTypes.bool.isRequired,
  runupRegions: ImmutablePropTypes.list.isRequired,
  runupCountries: ImmutablePropTypes.list.isRequired,
  runupAreas: ImmutablePropTypes.list.isRequired,
  runupRunupCountries: ImmutablePropTypes.list.isRequired,
  runupRunupAreas: ImmutablePropTypes.list.isRequired,
  runupRunupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  runupValidities: ImmutablePropTypes.list.isRequired,
  runupCauses: ImmutablePropTypes.list.isRequired,

  damageDescriptors: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  homeDescriptors: ImmutablePropTypes.list.isRequired,

  selectedEqCountry: PropTypes.string.isRequired,
  selectedEqArea: PropTypes.string.isRequired,
  selectedTsuCountry: PropTypes.string.isRequired,
  selectedTsuArea: PropTypes.string.isRequired,
  selectedTsuRunupCountry: PropTypes.string.isRequired,
  selectedTsuRunupArea: PropTypes.string.isRequired,
  selectedRunupCountry: PropTypes.string.isRequired,
  selectedRunupArea: PropTypes.string.isRequired,
  selectedRunupRunupCountry: PropTypes.string.isRequired,
  selectedRunupRunupArea: PropTypes.string.isRequired,

  history: PropTypes.shape({}).isRequired,
};

const mapStateToProps = state => ({
  searching: state.getIn(['referenceSearchPage', 'searching']),
  selectedEqCountry: state.getIn([model, 'eqCountry']),
  selectedEqArea: state.getIn([model, 'eqArea']),

  selectedTsuCountry: state.getIn([model, 'tsuCountry']),
  selectedTsuArea: state.getIn([model, 'tsuArea']),
  selectedTsuRunupCountry: state.getIn([model, 'tsuRunupCountry']),
  selectedTsuRunupArea: state.getIn([model, 'tsuRunupArea']),

  selectedRunupCountry: state.getIn([model, 'runupCountry']),
  selectedRunupArea: state.getIn([model, 'runupArea']),
  selectedRunupRunupCountry: state.getIn([model, 'runupRunupCountry']),
  selectedRunupRunupArea: state.getIn([model, 'runupRunupArea']),

  fetched: [

    state.getIn(['referenceSearchPage', 'fetchedHaves']),
    state.getIn(['referenceSearchPage', 'eqFetchedRegions']),
    state.getIn(['referenceSearchPage', 'eqFetchedCountries']),

    state.getIn(['referenceSearchPage', 'volFetchedRegions']),
    state.getIn(['referenceSearchPage', 'volFetchedCountries']),
    state.getIn(['referenceSearchPage', 'volFetchedVolcanoNames']),
    state.getIn(['referenceSearchPage', 'volFetchedMorphologies']),

    state.getIn(['referenceSearchPage', 'volLocFetchedRegions']),
    state.getIn(['referenceSearchPage', 'volLocFetchedCountries']),
    state.getIn(['referenceSearchPage', 'volLocFetchedMorphologies']),
    state.getIn(['referenceSearchPage', 'volLocFetchedStatuses']),
    state.getIn(['referenceSearchPage', 'volLocFetchedEruptionTimes']),

    state.getIn(['referenceSearchPage', 'tsuFetchedRegions']),
    state.getIn(['referenceSearchPage', 'tsuFetchedCountries']),
    state.getIn(['referenceSearchPage', 'tsuFetchedRunupCountries']),
    state.getIn(['referenceSearchPage', 'tsuFetchedRunupMeasurementTypes']),
    state.getIn(['referenceSearchPage', 'tsuFetchedValidities']),
    state.getIn(['referenceSearchPage', 'tsuFetchedCauses']),

    state.getIn(['referenceSearchPage', 'depFetchedPublications']),
    state.getIn(['referenceSearchPage', 'depFetchedCountries']),
    state.getIn(['referenceSearchPage', 'depFetchedBodiesOfWater']),
    state.getIn(['referenceSearchPage', 'depFetchedGeologicAges']),

    state.getIn(['referenceSearchPage', 'runupFetchedRegions']),
    state.getIn(['referenceSearchPage', 'runupFetchedCountries']),
    state.getIn(['referenceSearchPage', 'runupFetchedRunupCountries']),
    state.getIn(['referenceSearchPage', 'runupFetchedRunupMeasurementTypes']),
    state.getIn(['referenceSearchPage', 'runupFetchedValidities']),
    state.getIn(['referenceSearchPage', 'runupFetchedCauses']),
  ].every(v => v),
  haves: state.getIn(['referenceSearchPage', 'haves']),

  eqFetchingAreas: state.getIn(['referenceSearchPage', 'eqFetchingAreas']),
  eqRegions: state.getIn(['referenceSearchPage', 'eqRegions']),
  eqCountries: state.getIn(['referenceSearchPage', 'eqCountries']),
  eqAreas: state.getIn(['referenceSearchPage', 'eqAreas']),

  volCountries: state.getIn(['referenceSearchPage', 'volCountries']),
  volRegions: state.getIn(['referenceSearchPage', 'volRegions']),
  volVolcanoNames: state.getIn(['referenceSearchPage', 'volVolcanoNames']),
  volMorphologies: state.getIn(['referenceSearchPage', 'volMorphologies']),

  volLocCountries: state.getIn(['referenceSearchPage', 'volLocCountries']),
  volLocRegions: state.getIn(['referenceSearchPage', 'volLocRegions']),
  volLocMorphologies: state.getIn(['referenceSearchPage', 'volLocMorphologies']),
  volLocStatuses: state.getIn(['referenceSearchPage', 'volLocStatuses']),
  volLocEruptionTimes: state.getIn(['referenceSearchPage', 'volLocEruptionTimes']),

  tsuFetchingAreas: state.getIn(['referenceSearchPage', 'tsuFetchingAreas']),
  tsuFetchingRunupAreas: state.getIn(['referenceSearchPage', 'tsuFetchingRunupAreas']),
  tsuRegions: state.getIn(['referenceSearchPage', 'tsuRegions']),
  tsuCountries: state.getIn(['referenceSearchPage', 'tsuCountries']),
  tsuAreas: state.getIn(['referenceSearchPage', 'tsuAreas']),
  tsuRunupCountries: state.getIn(['referenceSearchPage', 'tsuRunupCountries']),
  tsuRunupAreas: state.getIn(['referenceSearchPage', 'tsuRunupAreas']),
  tsuRunupMeasurementTypes: state.getIn(['referenceSearchPage', 'tsuRunupMeasurementTypes']),
  tsuValidities: state.getIn(['referenceSearchPage', 'tsuValidities']),
  tsuCauses: state.getIn(['referenceSearchPage', 'tsuCauses']),

  depCountries: state.getIn(['referenceSearchPage', 'depCountries']),
  depBodiesOfWater: state.getIn(['referenceSearchPage', 'depBodiesOfWater']),
  depPublications: state.getIn(['referenceSearchPage', 'depPublications']),
  depGeologicAges: state.getIn(['referenceSearchPage', 'depGeologicAges']),

  runupFetchingAreas: state.getIn(['referenceSearchPage', 'runupFetchingAreas']),
  runupFetchingRunupAreas: state.getIn(['referenceSearchPage', 'runupFetchingRunupAreas']),
  runupRegions: state.getIn(['referenceSearchPage', 'runupRegions']),
  runupCountries: state.getIn(['referenceSearchPage', 'runupCountries']),
  runupAreas: state.getIn(['referenceSearchPage', 'runupAreas']),
  runupRunupCountries: state.getIn(['referenceSearchPage', 'runupRunupCountries']),
  runupRunupAreas: state.getIn(['referenceSearchPage', 'runupRunupAreas']),
  runupRunupMeasurementTypes: state.getIn(['referenceSearchPage', 'runupRunupMeasurementTypes']),
  runupValidities: state.getIn(['referenceSearchPage', 'runupValidities']),
  runupCauses: state.getIn(['referenceSearchPage', 'runupCauses']),

  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  homeDescriptors: state.getIn(['effectDescriptors', 'houses']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchReferences: searchReferencesAc,
  clearReferenceSearch: clearReferenceSearchAc,
  resetForm: () => actions.reset(model),
  resetField: field => actions.setInitial(`model.${field}`),
  change: (field, value) => actions.change(`${model}${field}`, value),
  getHaves: getHavesAc,

  // ASSOCIATED
  getEqRegions: getEqRegionsAc,
  getEqCountries: getEqCountriesAc,
  getEqAreas: getEqAreasAc,

  getVolCountries: getVolCountriesAc,
  getVolRegions: getVolRegionsAc,
  getVolVolcanoNames: getVolVolcanoNamesAc,
  getVolMorphologies: getVolMorphologiesAc,

  getVolLocRegions: getVolLocRegionsAc,
  getVolLocCountries: getVolLocCountriesAc,
  getVolLocMorphologies: getVolLocMorphologiesAc,
  getVolLocEruptionTimes: getVolLocEruptionTimesAc,
  getVolLocStatuses: getVolLocStatusesAc,

  getTsuRegions: getTsuRegionsAc,
  getTsuCountries: getTsuCountriesAc,
  getTsuAreas: getTsuAreasAc,
  getTsuRunupCountries: getTsuRunupCountriesAc,
  getTsuRunupAreas: getTsuRunupAreasAc,
  getTsuRunupMeasurementTypes: getTsuRunupMeasurementTypesAc,
  getTsuValidities: getTsuValiditiesAc,
  getTsuCauses: getTsuCausesAc,

  getDepPublications: getDepPublicationsAc,
  getDepGeologicAges: getDepGeologicAgesAc,
  getDepBodiesOfWater: getDepBodiesOfWaterAc,
  getDepCountries: getDepCountriesAc,

  getRunupRegions: getRunupRegionsAc,
  getRunupCountries: getRunupCountriesAc,
  getRunupAreas: getRunupAreasAc,
  getRunupRunupCountries: getRunupRunupCountriesAc,
  getRunupRunupAreas: getRunupRunupAreasAc,
  getRunupRunupMeasurementTypes: getRunupRunupMeasurementTypesAc,
  getRunupCauses: getRunupCausesAc,
  getRunupValidities: getRunupValiditiesAc,

}, dispatch);

export const ReferenceSearchPage = connect(mapStateToProps, mapDispatchToProps)(ReferenceSearchPageUnwrapped);
